import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[800px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-4">
          {contactData.title}
        </h2>
        <p className="text-base text-foreground-600 text-center mb-8">
          {contactData.description}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
          <div className="flex items-center gap-3 p-4 rounded-lg bg-background-100 border border-background-200/70">
            <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg shrink-0">
              <i className="ri-mail-line text-lg text-primary-600"></i>
            </div>
            <div className="min-w-0">
              <div className="text-xs text-foreground-500">邮箱</div>
              <div className="text-sm text-foreground-800 truncate">{contactData.email}</div>
            </div>
          </div>
          <div className="flex items-center gap-3 p-4 rounded-lg bg-background-100 border border-background-200/70">
            <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg shrink-0">
              <i className="ri-qq-line text-lg text-accent-600"></i>
            </div>
            <div className="min-w-0">
              <div className="text-xs text-foreground-500">QQ</div>
              <div className="text-sm text-foreground-800 truncate">{contactData.qq}</div>
            </div>
          </div>
          <div className="flex items-center gap-3 p-4 rounded-lg bg-background-100 border border-background-200/70">
            <div className="w-10 h-10 flex items-center justify-center bg-secondary-100 rounded-lg shrink-0">
              <i className="ri-wechat-line text-lg text-secondary-600"></i>
            </div>
            <div className="min-w-0">
              <div className="text-xs text-foreground-500">微信</div>
              <div className="text-sm text-foreground-800 truncate">{contactData.wechat}</div>
            </div>
          </div>
        </div>

        <form
          data-readdy-form
          action="https://readdy.ai/api/form/d9k39eec26n1c7c5qbpg"
          method="POST"
          className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70"
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
            <input
              name="name"
              type="text"
              placeholder="你的名字"
              required
              className="w-full px-4 py-2.5 text-sm rounded-lg bg-background-50 border border-background-200/70 text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors"
            />
            <input
              name="email"
              type="email"
              placeholder="你的邮箱"
              required
              className="w-full px-4 py-2.5 text-sm rounded-lg bg-background-50 border border-background-200/70 text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors"
            />
          </div>
          <textarea
            name="message"
            placeholder="请描述你的合作意向或建议..."
            maxLength={500}
            required
            className="w-full px-4 py-2.5 text-sm rounded-lg bg-background-50 border border-background-200/70 text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors resize-none h-28 mb-4"
          ></textarea>

          <div className="form-website-alt-field">
            <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden readOnly />
          </div>

          <div className="flex items-center justify-between">
            <span className="text-xs text-foreground-400">我们会在1-3个工作日内回复</span>
            <button
              type="submit"
              className="px-6 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              发送消息
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}